<template>
  <gh-code-editor v-model="code" :options="codeOptions" @submit="submit" @cancel="cancel"></gh-code-editor>
</template>

<style scoped>

</style>

<script>
  import EditCode from "./editCode.ts";
  export default EditCode;
</script>